import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { FormGroup } from '@angular/forms';
import { MedicalScheme, MedicalSchemesRepositoryService } from '@xmedical/core';
import { Observable } from 'rxjs';
import { map, startWith, switchMap } from 'rxjs/operators';
import { MedicalAidFormShape } from '../patient-form.service';

@Component({
  selector: 'app-patient-medical-aid-fieldset',
  templateUrl: './patient-medical-aid-fieldset.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PatientMedicalAidFieldsetComponent {
  private medicalSchemesRepository = inject(MedicalSchemesRepositoryService);

  readonly group = input.required<FormGroup<MedicalAidFormShape>>();

  // Bridge form value changes into a signal. Switching on `group()` lets the
  // subscription follow if the parent ever swaps the input reference.
  readonly hasScheme = toSignal(
    toObservable(this.group).pipe(
      switchMap(g => g.controls.scheme.valueChanges.pipe(
        startWith(g.controls.scheme.value),
        map(v => !!v),
      )),
    ),
    { initialValue: false },
  );

  searchSchemes = (query: string): Observable<MedicalScheme[]> => {
    return this.medicalSchemesRepository.query(query);
  };

  setMedicalScheme(scheme: MedicalScheme): void {
    const c = this.group().controls;
    c.schemeId.setValue(scheme.id);
    c.scheme.setValue(scheme.name);
    c.destinationCode.setValue(scheme.destinationCode);
  }

  clearMedicalScheme(): void {
    const c = this.group().controls;
    c.schemeId.setValue('');
    c.scheme.setValue('');
    c.destinationCode.setValue('');
  }
}
